import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function Section({ title, description, children, showBack = true }: { title: string; description?: string; children: ReactNode; showBack?: boolean }) {
  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-2">
        {showBack && (
          <Link
            to="/kpi"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-emerald-600 hover:text-emerald-700 transition w-fit"
          >
            <ArrowLeft size={16} /> Volver a KPIs
          </Link>
        )}
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          {description && <p className="text-sm text-gray-500 mt-0.5">{description}</p>}
        </div>
      </div>
      <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
        {children}
      </div>
    </div>
  );
}

